import { render } from "./FuneralKioskFormType2.vue?vue&type=template&id=3ca4f356&lang=true"
import script from "./FuneralKioskFormType2.vue?vue&type=script&lang=js"
export * from "./FuneralKioskFormType2.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__